import { computed } from "mobx";
import { observer } from "mobx-react";
import { DatePicker, IDatePickerStrings } from 'office-ui-fabric-react/lib/DatePicker';
import * as React from "react";
import { CloseButton } from "../Buttons/CloseButton";
import { InputDate } from "../Shared";
import { Strings } from "../Stores/StringsStore";

export interface IInputDateComponentProps {
	model: InputDate;
	locale: string;
	clearable: boolean;
	onChange?: () => void;
	testId?: string;
	placeHolder?: string;
}

@observer
export class InputDateComponent extends React.Component<IInputDateComponentProps, {}> {

	handleChange = (date: Date) => {
		if (!date) {
			this.props.model.value = null;
			this.props.model.isValid = true;
		}
		else {
			date = new Date(date.valueOf());
			date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
			if (this.props.model.value != date) {
				this.props.model.value = date;
				this.props.model.isValid = true;
				if (this.props.onChange) {
					this.props.onChange();
				}
			}
		}
	}

	@computed get value() {
		return new Date(this.props.model.value.toString());
	}

	valueString = (date: Date) => {
		return date ? new Date(date.toString()).toLocaleString(this.props.locale, { year: "numeric", month: "short", day: "2-digit" }) : null;
	}

	dayPickerStrings: IDatePickerStrings = {
		months: [Strings.datePicker.january, Strings.datePicker.february, Strings.datePicker.march, Strings.datePicker.april, Strings.datePicker.may, Strings.datePicker.june, Strings.datePicker.july, Strings.datePicker.august, Strings.datePicker.september, Strings.datePicker.october, Strings.datePicker.november, Strings.datePicker.december],

		shortMonths: [Strings.datePicker.january.substr(0, 2), Strings.datePicker.february.substr(0, 2), Strings.datePicker.march.substr(0, 2), Strings.datePicker.april.substr(0, 2), Strings.datePicker.may.substr(0, 2), Strings.datePicker.june.substr(0, 2), Strings.datePicker.july.substr(0, 2), Strings.datePicker.august.substr(0, 2), Strings.datePicker.september.substr(0, 2), Strings.datePicker.october.substr(0, 2), Strings.datePicker.november.substr(0, 2), Strings.datePicker.december.substr(0, 2)],

		days: [Strings.datePicker.sunday, Strings.datePicker.monday, Strings.datePicker.tuesday, Strings.datePicker.wednesday, Strings.datePicker.thursday, Strings.datePicker.friday, Strings.datePicker.saturday],

		shortDays: [Strings.datePicker.sunday.charAt(0), Strings.datePicker.monday.charAt(0), Strings.datePicker.tuesday.charAt(0), Strings.datePicker.wednesday.charAt(0), Strings.datePicker.thursday.charAt(0), Strings.datePicker.friday.charAt(0), Strings.datePicker.saturday.charAt(0)],

		goToToday: null
	};

	clear = () => {
		this.props.model.value = null;
	}

	render() {
		let label = this.props.model.label;
		let date = this.props.model && this.props.model.value && new Date(this.props.model.value.toString());
		return <div className="datepicker" title="">
			{label ? <span>{label}</span> : null}

			<DatePicker strings={this.dayPickerStrings} placeholder={this.props.placeHolder}
				value={this.props.model.value ? this.value : null}
				onSelectDate={this.handleChange}
				disabled={this.props.model.isReadOnly}
				className={!this.props.model.isValid ? "is--input-invalid" : null}
				formatDate={this.valueString}
				showGoToToday={false}
				data-test-id={this.props.testId} />
			{this.props.clearable ? <CloseButton onClick={this.clear} disabled={!this.props.model.value} /> : null}

			{this.props.model.validationMessage ? <span>{this.props.model.validationMessage}</span> : null}
		</div>;
	}
}